import { getCurrentInstance } from "vue";

export const useGridEditor = () => {

  const { proxy } = getCurrentInstance();

  /**
   * Lấy payload query dữ liệu remote
   * nmtuan4 18.10.2023
   */
  function getRemotePayload(queryString, displayField, valueField, cols) {
    let me = proxy,
      filters = [],
      filterFields = {};

    if (queryString) {
      let filter = {
        Field: displayField,
        Operator: proxy.$ms.constant.FilterOperator.In,
        Value: queryString,
      };
      filters.push(filter);
    }
    let payload = {};
    if (filters.length > 0) {
      payload.filter = JSON.stringify(filters);
    }

    let columns = [displayField, valueField];
    if (cols && cols.length > 0) {
      cols.forEach(item => {
        if (item.dataField && columns.indexOf(item.dataField) === -1) {
          columns.push(item.dataField);
        }
      });
    }

    columns = columns.distinctKey();

    payload.columns = columns.join(',');

    payload.selectedItem = JSON.stringify({
      [displayField]: '',
      [valueField]: ''
    });

    return payload;
  }

  return {
    getRemotePayload
  };
};
